"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var dataSources;
        (function (dataSources) {
            var create;
            (function (create) {
                function init() {
                    addEvents();
                }
                create.init = init;
                function addEvents() {
                    $('#saveLink').click(function () {
                        $('form#appnForm').submit();
                    });
                }
            })(create = dataSources.create || (dataSources.create = {}));
        })(dataSources = views.dataSources || (views.dataSources = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
